export default {
  HOST: window.location.hostname,
  PORT: window.location.port
};
